export const ARCHITECT_CONTRACT_FILE_URL =
  'https://cdn.leroymerlin.com.br/files/Opt+In+-+Programa+fidelidade+Arquitetos+-+VF.pdf'
